import toast from './toast';

const APP_URL = process.env.REACT_APP_APP_URL || 'https://app.damelsoft.com.br';

export async function compartilhar(pontos) {
  const text = pontos > 0
    ? `⚽ Estou participando do Palpitar e já tenho ${pontos} pontos!\n\nFaça seus palpites, suba no ranking e troque pontos por brindes.\n\nAcesse: ${APP_URL}`
    : `⚽ Estou participando do Palpitar!\n\nFaça seus palpites, acumule pontos e troque por brindes.\n\nAcesse: ${APP_URL}`;

  if (navigator.share) {
    try {
      await navigator.share({ text });
    } catch (_) {
      // usuário fechou o share sheet — sem ação
    }
    return;
  }

  // fallback: copia para a área de transferência
  try {
    await navigator.clipboard.writeText(text);
    toast.success('Texto copiado! Cole no WhatsApp ou onde quiser.');
  } catch (_) {
    toast.error('Não foi possível compartilhar. Tente pelo WhatsApp.');
  }
}
